/**
 * @param {Object} portfolio
 *
 * @return {Object}
 */
export default function normalizePortfolio(portfolio) {
  return {
    ...portfolio,
    name: portfolio.full_name,
    shortName: portfolio.short_name
  };
}
